import { FilterSection } from "@flights/search-ui";
import React from "react";
import { useAirlinesFilterController } from "./useAirlinesFilter.controller.js";
import AirlinesFilterItem from "./AirlinesFilterItem.js";
import { AirlinesFilterOptions } from "./AirlinesFilterOptions.js";
import { useTrackLayoverPriceAirportFilterWeb } from "../../../../../utils/experiments/funnel/flights_funnel_layover_price_airport_filter_web.js";
import { t, useI18n } from "@bookingcom/lingojs-react";
export const AirlinesFilterDesktop = () => {
    const { isFilterAvailable, title, showReset, resetLabel, onClickReset, options, value, onChange, onSelectSingleOption, optionsLimit, areOptionsTrucanted, optionsTogglerLabel, optionsTogglerAriaLabel, optionsTogglerIcon, onTogglerClick, singleOptionLabel } = useAirlinesFilterController();
    const i18n = useI18n();
    const trackLayoverPriceAirportFilterWeb = useTrackLayoverPriceAirportFilterWeb();
    if (!isFilterAvailable)
        return null;
    return (React.createElement(FilterSection, { attributes: { "data-testid": "airlines_filter" }, title: {
            text: title,
            tagName: "h3",
            attributes: { id: "airlines_filter" },
            variant: trackLayoverPriceAirportFilterWeb() ? "strong_2" : "emphasized_1"
        }, reset: showReset
            ? {
                text: resetLabel,
                onClick: onClickReset,
                attributes: {
                    "data-testid": "search_filter_airline_reset",
                    "aria-label": i18n.trans(t("a11y_flights_filter_reset_airlines"))
                }
            }
            : undefined },
        React.createElement(AirlinesFilterOptions, { gap: 2, togglerLabel: optionsTogglerLabel, togglerAriaLabel: optionsTogglerAriaLabel, togglerIcon: optionsTogglerIcon, onTogglerClick: onTogglerClick, options: options, optionsLimit: optionsLimit, areOptionsTrucanted: areOptionsTrucanted, renderOption: ({ option, isHidden, index }) => (React.createElement(AirlinesFilterItem, { key: `${index}-${option.value}`, value: option.value, label: option.label, count: option.count, checked: value.includes(option.value), onChange: onChange, isHidden: isHidden, canSelectSingleOption: true, onSelectSingleOption: onSelectSingleOption, singleOptionLabel: singleOptionLabel, showNewBadge: option.showNewBadge })) })));
};
